module.exports = __webpack_public_path__ + "media/images/extension-onboarding/pin-8817e36a794150034adc4f19fc4a92d9.png";